/**
 * 模块 - 财务中心 - 英文
 */
export default {
  finance: {
    // Account Assets Board
    accountAssets: 'Account Assets',
    accountAssetsBoard: 'Account Assets Board',
    dataStatsCutoff: 'Data statistics cutoff time: ',
    accountBalance: 'Account Balance',
    commonAccount: 'Common Account',
    agentAccount: 'Agent Account',
    companyAccount: 'Company Account',
    voucherAccount: 'Voucher Bonus Account',
    goldAccount: 'Gold Account',
    cashAccount: 'Cash Account',
    withdrawalAccount: 'Withdrawal Account',
    bankTransfer: 'Bank Transfer',
    hqCoBuildAccount: 'HQ Co-build Account',
    convertibleOptionAmount: 'Convertible Option Amount',
    promotionAmount: 'Promotion Fee',
    cityAmount: 'City Fee',
    deliveryVoucherAccount: 'Delivery Voucher Account',
    deliveryVoucherShort: 'Delivery Voucher',
    deliveryAccountBalance: 'Delivery Voucher Balance',
    issuedDeliveryVoucher: 'Issued Delivery Vouchers',
    verifiedDeliveryVoucher: 'Verified Delivery Vouchers',
    dualOrderPendingReturnVoucher: 'Dual Order Pending Return Vouchers',
    equipmentAssets: 'Equipment Assets',
    equipmentType: 'Equipment Type',
    cashAmount: 'Cash Amount',
    voucherAmount: 'Voucher Amount',
    totalAmount: 'Total',
    freightAmount: 'Freight',
    orderAssets: 'Order Assets',
    purchaseOrder: 'Purchase Order',
    undeliveredPurchaseTotal: 'Undelivered Purchase Total',
    undeliveredPurchaseCash: 'Undelivered Purchase Cash',
    undeliveredPurchaseVoucher: 'Undelivered Purchase Voucher',
    creditOrderUndeliveredTotal: 'Credit Order Undelivered Paid Total',
    creditOrderUndeliveredCash: 'Credit Order Undelivered Paid Cash',
    creditOrderUndeliveredVoucher: 'Credit Order Undelivered Paid Voucher',
    deliveryOrder: 'Delivery Order',
    shippedUnpaidTotal: 'Shipped Unpaid Total',
    shippedUnpaidCash: 'Shipped Unpaid Cash',
    shippedUnpaidVoucher: 'Shipped Unpaid Voucher',
    creditOrderShippedUnpaidTotal: 'Credit Order Shipped Unpaid Total',
    creditOrderShippedUnpaidCash: 'Credit Order Shipped Unpaid Cash',
    creditOrderShippedUnpaidVoucher: 'Credit Order Shipped Unpaid Voucher',
    noDetailPermission: 'You do not have permission to access this page.',

    // Agent Account
    expenseRecord: 'Expense Record',
    rechargeRecord: 'Recharge Record',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    transfer: 'Transfer',
    inventoryValue: 'Inventory Value',
    includeVoucher: 'incl. Voucher',
    pay: 'Pay',
    remainingUnorderedAmount: 'Remaining Unordered Amount',
    detail: 'Detail',
    totalPaymentAmount: 'Total Payment Amount',
    paidPaymentAmount: 'Paid Payment Amount',
    withdrawableAmount: 'Withdrawable Amount',
    loanAmount: 'Loan Type',
    notLoanAmount: 'Non-Loan Type',
    loanAmountLabel: 'Loan Amount',
    notLoanAmountLabel: 'Non-Loan Amount',
    inventoryValueTipA: 'Total purchase price of unactivated full-price learning machines in inventory',
    inventoryValueTipB: 'Parent-child machines and samples excluded',

    // Recharge Record
    serialNo: 'Serial No.',
    rechargeAmount: 'Recharge Amount',
    rechargeMethod: 'Recharge Method',
    rechargeTime: 'Recharge Time',
    accountType: 'Account Type',
    account: 'Account',
    operator: 'Operator',
    remark: 'Remark',
    rechargeSerial: 'Recharge Serial',
    pleaseEnterRechargeSerial: 'Enter recharge serial',
    pleaseSelectAccountType: 'Select account type',
    pleaseSelectRechargeMethod: 'Select recharge method',

    // Withdrawal Record
    withdrawalSerial: 'Withdrawal Serial',
    pleaseEnterWithdrawalSerial: 'Enter withdrawal serial',
    withdrawalTime: 'Withdrawal Time',
    withdrawalAmount: 'Withdrawal Amount',
    paymentCategoryWithdrawAmount: 'Loan Category Withdraw Amount',
    noPaymentCategoryWithdrawAmount: 'Non-Loan Category Withdraw Amount',
    paymentCategoryTransferAmountTotal: 'Loan Category Transfer Amount Total',
    noPaymentCategoryTransferAmountTotal: 'Non-Loan Category Transfer Amount Total',
    rechargeType: 'Recharge Type',
    paymentCategoryType: 'Payment category',
    nonPaymentCategoryType: 'Non-payment category',
    transferAmount: 'Transfer Amount',
    transferTime: 'Transfer Time',
    cashAccountTransferTime: 'Transfer Time',
    transferAccountType: 'Transfer Account Type',
    payTimeLabel: 'Payment Time',
    paymentFlowTime: 'Payment Time',
    paymentUser: 'Payment User',
    project: 'Project',
    pleaseSelectProject: 'Select project',
    valuation: 'Valuation',
    settlementNo: 'Settlement No.',
    pleaseEnterSettlementNo: 'Enter settlement no.',
    settlementAmount: 'Settlement Amount',
    receivedAmount: 'Paid Amount',
    expenditureMethod: 'Expenditure Method',
    pleaseSelectExpenditureMethod: 'Select expenditure method',
    queryListFail: 'Query list failed',

    pleaseSelectRechargeType: 'Select recharge type',
    applyOrderNo: 'Apply Order No',
    applyWithdrawAmount: 'Apply Withdraw Amount',
    pleaseEnterWithdrawAmount: 'Enter withdraw amount',
    applyStatus: 'Apply Status',
    pleaseSelectApplyStatus: 'Select apply status',
    withdrawStatusPendingSubmit: 'Pending submit',
    withdrawStatusPendingReview: 'Pending review',
    withdrawStatusReturned: 'Returned',
    withdrawStatusPendingPay: 'Pending payment',
    withdrawStatusCompleted: 'Completed',
    payeeName: 'Payee Name',
    pleaseEnterPayeeName: 'Enter payee name',
    depositBank: 'Deposit Bank',
    payeeReceivingBank: 'Receiving bank',
    bankInfoPlaceholder: 'Include province, city, head office and branch info',
    bankExample: 'e.g. ICBC Jiangsu Nanjing Fujian Road Branch',
    payeeAccount: 'Payee Account',
    pleaseEnterPayeeAccount: 'Enter payee account',
    contactPhone: 'Contact Phone',
    auditRemark: 'Audit Remark',
    invoiceUpload: 'Invoice Upload:',
    maxUpload5Pdf: 'Max 5 PDF files',
    noInvoiceData: 'No invoice info',
    invoiceUploadTip: 'Please upload red-stamp invoice first. If not available, upload screenshot of uninvoiced orders. Finance will deduct corresponding order invoice amount based on withdrawal amount.',
    invoiceInfo: 'Invoice Info:',
    invoiceUnit: 'Invoice Unit',
    invoiceItem: 'Invoice Item',
    invoiceAmount: 'Invoice Amount',
    invoiceN: 'Invoice {n}:',
    withdrawApplyDetail: 'Withdraw Apply Detail',
    withdrawApplySubmitInvoice: 'Withdraw Apply Submit Invoice',
    withdrawApplyModify: 'Withdraw Apply Modify',
    agent: 'Agent',
    agentId: 'Agent ID',
    agentName: 'Agent Name',
    applyType: 'Apply Type',
    applyAmount: 'Apply Amount',
    bankAccount: 'Bank Account',
    paymentTime: 'Payment Time',
    applyTime: 'Apply Time',
    submitTime: 'Submit Time',
    applicant: 'Applicant',
    auditor: 'Auditor',
    paymentUser: 'Payment User',
    pleaseEnterApplyOrderNo: 'Enter apply order no.',
    submitInvoice: 'Submit Invoice',
    confirmCancel: 'Confirm to cancel?',
    cashAccountDetail: 'Cash Account Detail',
    cashAccountSubmitInvoice: 'Cash Account Submit Invoice',
    cashAccountModify: 'Cash Account Modify',
    pleaseEnterApplyAmount: 'Enter apply amount',
    pleaseEnterTransferAmount: 'Enter transfer amount',
    withdrawAccountInsufficient: 'Insufficient withdrawal account balance!',
    noInvoiceConfirmSubmit: 'No invoice uploaded. Confirm to submit for HQ finance review?',
    pleaseEnterContact: 'Enter contact info',
    refundRecordListExport: 'Refund Record List Export',

    // Refund page (OrganizationManage/Refund)
    refundInfo: 'Refund Info',
    refundSignMain: 'Sign Main',
    refundOrgIdName: 'Org ID/Name',
    refundHandStatus: 'Handover Status',
    refundStatusLabel: 'Refund Status',
    refundTotalAmount: 'Total Refund Amount',
    refundTotalAmountPlaceholder: 'Enter total refund amount',
    deductAmount: 'Deduct Amount',
    deductAmountPlaceholder: 'Enter deduct amount',
    convertOption: 'Convert Option',
    convertOptionPlaceholder: 'Enter convert option',
    exchangeClassFee: 'Exchange Class Fee',
    exchangeAmountPlaceholder: 'Enter exchange amount',
    actualRefundAmount: 'Actual Refund Amount',
    actualRefundAmountPlaceholder: 'Enter actual refund amount',
    terminationAgreementEndTime: 'Termination Agreement End Time',
    terminationAgreementEntryTime: 'Termination Agreement Entry Time',
    refundMethod: 'Refund Method',
    refundMethodPlaceholder: 'Enter refund method',
    refundReasonLabel: 'Refund Reason',
    refundReasonPlaceholder: 'Enter refund reason',
    firstRefundTimeLabel: 'First Payment Time',
    firstRefundAmountLabel: 'First Payment Amount',
    secondRefundTimeLabel: 'Second Payment Time',
    secondRefundAmountLabel: 'Second Payment Amount',
    lastRefundTimeLabel: 'Last Payment Time',
    lastRefundAmountLabel: 'Last Payment Amount',
    otherLoanTimeLabel: 'Other Payment Time',
    otherLoanAmountLabel: 'Other Payment Amount',
    otherLoanAmountPlaceholder: 'Enter other payment amount',
    otherLoanRemarkLabel: 'Other Payment Remark',
    otherLoanRemarkPlaceholder: 'Enter remark',
    refundCycleLabel: 'Payment Installment',
    refundCyclePlaceholder: 'Enter installment',
    terminationAttachmentLabel: 'Attachment (Termination Agreement):',
    uploadFileButton: 'Upload File',
    refundPaymentInfo: 'Refund Payment Info',
    attachment: 'Attachment',
    addRefundPaymentInfoTitle: 'Add Refund Payment Info',
    refundAmountLabel: 'Refund Amount',
    refundAmountPlaceholder: 'Enter refund amount',
    refundAccountLabel: 'Refund Account',
    refundAccountPlaceholder: 'Enter refund account',
    refundTimeLabel: 'Payment Time',
    refundRemarkLabel: 'Remark',
    refundRemarkPlaceholder: 'Enter remark',
    attachmentLabel: 'Attachment',
    uploadAttachmentButton: 'Upload Attachment',
    cancelRefund: 'Cancel Refund',
    cancelRefundConfirmPrefix: 'Confirm to cancel refund for "',
    cancelRefundConfirmSuffix: '"?',
    maxUpload50M: 'Max file size 50M',
    uploadSuccessWithName: '{name} uploaded successfully',
    uploadFailWithName: '{name} upload failed',
    productModel: 'Product Model',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    orderNo: 'Order No',
    pleaseSelectRechargeMethod: 'Select recharge method',

    // Expense Record
    orderNo: 'Order No',
    buyNum: 'Quantity',
    orderAmount: 'Order Amount',
    payAmount: 'Pay Amount',
    payMethod: 'Pay Method',
    payTime: 'Pay Time',
    pleaseEnterOrderNo: 'Enter order no.',

    // Purchase Order headTools
    purchaseExport: 'Purchase Export',
    deliveryInfoExport: 'Delivery Info Export',
    deliveryInfoImport: 'Delivery Info Import',
    allocateManufacturer: 'Allocate Manufacturer',
    generateDeliveryOrder: 'Generate Delivery Order',
    splitDelivery: 'Split Delivery',
    deliveryOrderNo: 'Delivery Order No.',
    createTime: 'Create Time',
    creator: 'Creator',
    operation: 'Operation',
    initialPayment: 'Initial Payment',
    more: 'More',
    performanceSplit: 'Performance Split',
    delete: 'Delete',
    discount: 'Discount',
    drawInvoice: 'Draw Invoice',
    printDeliveryOrder: 'Print Delivery Order',
    returnGoods: 'Return Goods',
    returnFreight: 'Return Freight',
    manufacturer: 'Manufacturer',
    pleaseSelectManufacturer: 'Select manufacturer',
    cancel: 'Cancel',
    confirm: 'Confirm',
    deliveryOrderConfirm: 'Delivery Order Confirm',
    productName: 'Product Name',
    waitSendNum: 'Wait Send Qty',
    thisDeliveryNum: 'This Delivery Qty',
    pleaseEnterDeliveryNum: 'Enter delivery qty',
    allocateManufacturerSuccess: 'Manufacturer allocated successfully',
    allocateManufacturerFail: 'Failed to allocate manufacturer',
    generateDeliverySuccess: 'Delivery order generated successfully!',
    generateDeliveryFail: 'Failed to generate delivery order!',
    splitDeliverySuccess: 'Delivery split successfully!',
    splitDeliveryFail: 'Failed to split delivery!',
    pleaseSelectOrder: 'Select order(s)',
    pleaseSelectDeliveryOrder: 'Select delivery order(s)',
    pleaseSelectPurchaseOrder: 'Select purchase order(s)',
    singleOrderSplitOnly: 'Only single order split supported',
    orderNotSupportSplit: 'This order does not support split',
    deliveryNumExceedWait: 'Delivery qty cannot exceed wait send qty',
    orderWithVoucherCannotCancel: 'This order has delivery vouchers and cannot be cancelled',
    pleaseEnterPositiveInteger: 'Enter a positive integer',
    exportDeliveryList: 'Delivery List Export',
    exportDeliveryInfo: 'Delivery Info Export',

    // Goods Transfer Record
    goodsTransferRecord: 'Goods Transfer Record',
    export: 'Export',
    snCode: 'SN Code',
    pleaseEnterSnCode: 'Enter SN code',
    transferOutAgent: 'Transfer Out Agent',
    transferInAgent: 'Transfer In Agent',
    pleaseSelectAgent: 'Select agent',
    transferTime: 'Transfer Time',
    productType: 'Product Type',
    currentAvailableSampleIndex: 'Current Available Sample Index',
    sampleIndexQueryExportFileName: 'Sample Index Query Export',
    sampleIndexRuleInterpretation: 'Rules and interpretation of sample device indicators',
    expenseCalendarPayTime: 'Payment Time',
    invoicePdf: 'Invoice.pdf',
    equityInfo: 'Equity Info',
    equityDescription: 'Equity Description',
    verificationInfo: 'Verification Info',
    pleaseSelectProductType: 'Select product type',
    deviceSnCode: 'Device SN Code',
    transferOutAgentId: 'Transfer Out Agent ID',
    transferOutAgentName: 'Transfer Out Agent Name',
    transferOutOrderNo: 'Transfer Out Order No.',
    transferInAgentId: 'Transfer In Agent ID',
    transferInAgentName: 'Transfer In Agent Name',
    transferInOrderNo: 'Transfer In Order No.',
    transferPerson: 'Transfer Person',
    hqTransferRecordExport: 'HQ Transfer Record Export',

    // Application Record
    applicationRecord: 'Experience Account Application Record',
    applicationDate: 'Application Date',
    applicationPhone: 'Application Phone',
    pleaseEnterPhone: 'Enter phone number',
    applicationTime: 'Application Time',
    experienceAccount: 'Experience Account',
    experienceAccountPassword: 'Experience Account Password',
    accountValidDate: 'Account Valid Date',

    // Common / Messages
    queryFail: 'Query failed',
    operationSuccess: 'Operation successful',
    operationFail: 'Operation failed',
    submitSuccess: 'Submitted successfully',
    submitFail: 'Submit failed',
    cancelSuccess: 'Cancelled successfully',
    cancelFail: 'Cancel failed',
    confirmSuccess: 'Confirmed successfully',
    confirmFail: 'Confirm failed',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    modifySuccess: 'Modified successfully',
    deleteSuccess: 'Deleted successfully!',
    withdrawSuccess: 'Withdrawal successful',
    pleaseEnterReimburseAmount: 'Please enter reimbursement amount',
    pleaseSelectExpressCompany: 'Please select express company',
    pleaseEnterExpressNo: 'Please enter express tracking number',
    pleaseEnterExpressPhone: 'Please enter express phone number',
    onlyUploadPdfPngJpg: 'Only pdf, png, jpg, jpeg files allowed',
    maxUpload20M: 'Max file size 20M',
    onlyUploadPngJpgPdf: 'Only png, jpg, jpeg, pdf files allowed',
    maxUpload5M: 'Max file size 5M',
    pleaseEnter11DigitPhone: 'Please enter 11-digit phone number',
    pleaseUploadAttachmentFirst: 'Please upload attachment first',
    pleaseSelectVisitRecordFirst: 'Please select visit record first',
    pleaseCompleteReimburseForm: 'Please complete reimbursement form first',
    noWithdrawData: 'No withdrawal data available',
    pleaseEnterPayeeName: 'Please enter payee name',
    pleaseEnterBankName: 'Please enter bank name',
    pleaseEnterPayeeAccount: 'Please enter payee account',
    pleaseEnterContactPhone: 'Please enter contact phone',
    noInvoiceUploadTip: 'Please upload invoice before submitting for HQ finance review.',
    operationFailRetry: 'Operation failed, please retry',
    getDataFail: 'Failed to get data',
    deleteFail: 'Delete failed',
    operationSuccessExclamation: 'Operation successful!',
    operationFailExclamation: 'Operation failed!',
    invoiceType: 'Invoice Type',
    pleaseEnterInvoiceType: 'Please select invoice type',
    operationNotAllowed: 'Operation not allowed',
    invoiceSuccess: 'Invoice created successfully',
    invoiceFail: 'Invoice creation failed',
    noValidUploadData: 'No valid data to upload',
    pleaseEnterPurchaseNo: 'Please enter purchase order no',
    onlyXlsxXlsFormat: 'Only .xlsx and .xls format supported',
    pleaseSelectFileFirst: 'Please select file first',
    importSuccess: 'Import successful',
    importFail: 'Import failed',
    onlyImageFormat: 'Only JPG, JPEG, GIF, PNG, BMP images allowed',
    exceed5MLimit: 'File size exceeds 5M limit',
    maxOneImage: 'Maximum 1 image allowed',
    pleaseSelectAgent: 'Please select agent',
    pleaseSelectAccountType: 'Please select account type',
    pleaseFillAmount: 'Please fill in amount',
    pleaseFillPayMethod: 'Please fill in payment method',
    pleaseSelectPayTime: 'Please select payment time',
    pleaseSelectRechargeTime: 'Select recharge time',
    pleaseSelectFlowStatus: 'Select flow status',
    paySerial: 'Pay Serial',
    pleaseFillPaySerial: 'Please fill in payment serial',
    pleaseUploadImage: 'Please upload image',
    fillError: 'Please correct the form',
    fail: 'Failed',
    totalLabel: 'Total: ',
    sendEmail: 'Send Email',
    deviceAmount: 'Device Amount',
    softwareAmount: 'Software Amount',
    recalcAmount: 'Recalculate Amount',
    save: 'Save',
    pleaseEnterEmail: 'Please enter email',
    invalidEmailFormat: 'Invalid email format!',
    pleaseEnterDeviceAmount: 'Please enter device amount',
    formatErrorNumber: 'Invalid format, please enter a number!',
    amountCannotBeNegative: 'Amount cannot be negative',
    pleaseEnterSoftwareAmount: 'Please enter software amount',
    pleaseSelectInvoiceType: 'Please select invoice type',

    // InvoiceHeader
    invoiceHeaderType: 'Invoice Header Type:',
    company: 'Company',
    personal: 'Personal',
    companyHead: 'Company Name:',
    pleaseFillCompanyHead: 'Enter company name',
    dutyParagraph: 'Tax ID:',
    pleaseFillDutyParagraph: 'Enter tax ID',
    phone: 'Phone:',
    pleaseFillPhone: 'Enter phone',
    address: 'Address:',
    pleaseFillAddress: 'Enter address',
    pleaseFillBank: 'Enter bank name',
    bankAccountColon: 'Bank Account:',
    pleaseFillBankAccount: 'Enter bank account',
    invoiceTypeColon: 'Invoice Type:',
    pleaseSelectInvoiceTypeColon: 'Select invoice type',
    email: 'Email:',
    emailLabel: 'Email',
    pleaseFillEmail: 'Enter email',
    businessLicense: 'Business License:',
    clickUploadImage: 'Click to upload',
    legalIdFront: 'Legal Rep ID Front:',
    legalIdBack: 'Legal Rep ID Back:',
    agentNameColon: 'Name:',
    pleaseFillName: 'Enter name',
    idCard: 'ID Card No.:',
    pleaseFillIdCard: 'Enter ID card no.',
    idCardFront: 'ID Card Front:',
    idCardBack: 'ID Card Back:',
    previewFile: 'Preview',
    deleteFile: 'Delete',
    emailRequired: 'Email is required',
    pleaseEnterValidEmail: 'Enter valid email format',
    pleaseUploadBusinessLicense: 'Upload business license',
    pleaseUploadLegalIdFront: 'Upload legal rep ID front',
    pleaseUploadLegalIdBack: 'Upload legal rep ID back',
    pleaseUploadIdCardFront: 'Upload ID card front',
    pleaseUploadIdCardBack: 'Upload ID card back',
    onlyImageFormatJpg: 'Only JPG, JPEG, GIF, PNG, BMP images allowed',
    exceed5MLimitUpload: 'File size exceeds 5M limit',
    applyWithdraw: 'Apply Withdraw',
    cashAccountTransfer: 'Transfer to Cash Account',
    autoCalcMaxWithdrawTip: 'Max withdraw amount is auto-calculated based on recharge type',
    saveAutoGenerate: 'Auto-generated on save, cannot be modified',
    maxWithdrawableAmount: 'Max Withdrawable Amount',
    maxApplyAmount: 'Max Apply Amount',
    contactAutoFromInvoice: 'Auto from invoice header, editable',
    close: 'Close',
    nonPaymentInvoiceTip: 'Non-payment Invoice Reminder',
    invoiceSubmitTip: 'After invoicing, go to Finance Center -> Agent Account -> Cash Transfer Apply to submit invoice',
    gotIt: 'Got it',
    paymentInvoiceTip: 'Payment Invoice Reminder',
    businessLicenseShort: 'Business License',
    idCardFrontShort: 'ID Card Front',
    idCardBackShort: 'ID Card Back',
    invoiceConfirmTip: 'Once invoice info is confirmed, it cannot be changed. Confirm?',
    cancelConfirm: 'Cancel Confirm',
    cancelConfirmTip: 'Cancel confirmation?',
    transferCashAccount: 'Transfer to Cash Account',
    rechargeNow: 'Recharge Now',
    note: 'Note:',
    deductStorageFee: 'Deduct Storage Fee',
    deductStorageFeeConfirm: 'Deduct storage management fee from distributor delivery voucher account?',
    deductStorageFeeCannotTip: 'Deducted or unconfirmed records cannot be deducted. Please reselect.',
    rechargeTypeLabel: 'Recharge Type',

    // Visit Reimbursement
    reimburseApply: 'Reimburse Apply',
    expressNo: 'Express No',
    attachment: 'Attachment',
    view: 'View',
    visitRecord: 'Visit Record',
    confirmCancelReimburse: 'Confirm to cancel this reimbursement?',
    viewAttachment: 'View Attachment',
    confirmDeleteRecord: 'This action will permanently delete the record. Continue?',
    visitCustomerName: 'Visit Customer Name',
    visitCustomerPhone: 'Visit Customer Phone',
    visitCampusId: 'Visit Campus ID',
    visitCampusName: 'Visit Campus Name',
    storeId: 'Store ID',
    visitStoreAddress: 'Visit Store Address',
    deliveryDate: 'Delivery Date',
    pleaseSelectSubscriptionAgent: 'Select subscription card agent',
    purchaseQty: 'Purchase Qty',
    invoiceConfirm: 'Invoice Confirm',
    regionAgentName: 'Region Agent Name',
    regionAgentId: 'Region Agent ID',
    returnAmount: 'Return Amount',
    currentBalance: 'Current Balance',
    confirmAmountLabel: 'Confirm Amount',
    confirmTime: 'Confirm Time',
    signTime: 'Sign Time',
    auditTime: 'Audit Time',
    to: 'to',
    reimburseNo: 'Reimburse No',
    pleaseEnterNo: 'Enter no',
    pleaseSelectStatus: 'Select status',
    createBy: 'Creator',
    agentLabel: 'Agent',
    reimburseTotalAmount: 'Reimburse Total Amount',
    expressCompany: 'Express Company',
    expressPhone: 'Express Phone',
    invoiceMailAddress: 'Invoice Mail Address',
    recipientInfo: 'Recipient Info',
    reimburseInvoiceUpload: 'Reimburse Invoice Upload',
    pleaseSelectVisitRecord: 'Select visit record',
    selectVisitRecord: 'Select Visit Record',
    confirmDelete: 'Confirm to delete?',
    reimburseTip: 'Please mail the paper invoice to the above address and fill in the correct express number for timely processing.',
    uploadPdfOrImage: 'Upload PDF or image',
    invoiceAddressExample: 'Building E, 5F, 1080 Lianhua Road, Minhang District, Shanghai',
    recipientInfoExample: 'Shen Mengyu 18918671328',

    // ShippingReturnBill / Statement Confirm
    statementConfirm: 'Statement Confirm',
    confirmResult: 'Confirm Result:',
    noWithdraw: 'No Withdraw',
    withdraw: 'Withdraw',
    payeeNameConsistent: 'Must match agent entity name',
    bankExampleShort: 'e.g. ICBC Jiangsu Nanjing Fujian Road Branch',
    confirmInvoiceAmountTotal: 'Confirmed Invoice Amount:',
    unconfirmInvoiceAmountTotal: 'Unconfirmed Invoice Amount:',
    statementConfirmTip1: '1. Once confirmed, withdraw will deduct from cash account immediately and cannot be changed;',
    statementConfirmTip2: '2. After confirmation, finance will make offline payment to regional agents;',
    statementConfirmTip3: '3. If withdrawing, please fill in payee account info accurately;',
    statementConfirmTip4: '4. If no withdraw, balance stays in account for order payment;',
    statementConfirmTip5: '5. Only confirmed invoice order refunds can be withdrawn;',

    // Return Application
    audit: 'Audit',
    return: 'Return',
    returnNo: 'Return No.',
    pleaseEnterReturnNo: 'Enter return no.',
    returnOrder: 'Return Order',
    subscriptionCashReturnAmount: 'Subscription Cash Return Amount',
    payVoucher: 'Pay Voucher',
    auditPass: 'Audit Pass',
    auditReject: 'Audit Reject',
    auditResult: 'Audit Result',
    invoiceAmountColon: 'Invoice Amount:',
    cashAccountReturnInfo: 'Cash Account Return Info',
    accountName: 'Account Name',
    accountNo: 'Account No.',
    returnRecord: 'Return Record',
    subscriptionVerifyDetail: 'Subscription Verify Detail',
    processTime: 'Process Time',
    processBy: 'Process By',
    processResult: 'Process Result',
    verifySerialNo: 'Verify Serial No.',
    subscriptionCardNo: 'Subscription Card No.',
    subscriptionCardType: 'Subscription Card Type',
    subscriptionAgentId: 'Subscription Agent ID',
    subscriptionAgentName: 'Subscription Agent Name',
    verifyTime: 'Verify Time',
    cashPayAmount: 'Cash Pay Amount',
    voucherPayAmount: 'Voucher Pay Amount',
    agentCashReturnAmount: 'Agent Cash Return Amount',
    agentVoucherReturnAmount: 'Agent Voucher Return Amount',
    status: 'Status',
    refundAmount: 'Refund Amount',
    refundAccount: 'Refund Account',
    refundTime: 'Refund Time',
    refundType: 'Refund Type',
    refundBy: 'Refund By',
    refundRecordOrderNo: 'Order No.',
    totalFlowCount: '{n} total flows, total pay amount ¥{m}',
    payAmountTotal: 'Payment amount total: ¥{m}',
    returnNoLabel: 'Return No.',
    applyStatusLabel: 'Status',
    pleaseSelectStatus: 'Select status',
    applyTimeLabel: 'Apply Time',
    cashReturnAmount: 'Cash Return Amount',
    fissionReturnAmount: 'Fission Return Amount',
    applicant: 'Applicant',
    lastEditTime: 'Last Edit Time',
    lastProcessor: 'Last Processor',
    expenditureMethod: 'Expenditure Method',
    payTypeLabel: 'Pay Type',
    accountChangeType: 'Account Change Type',
    pleaseSelectType: 'Select type',
    accountRecharge: 'Account Recharge',
    accountExpense: 'Account Expense',
    accountTransfer: 'Account Transfer',
    unread: 'Unread',
    read: 'Read',
    sendTime: 'Send Time',
    noticeContent: 'Notice Content',
    accountChangeNotice: 'Account Change Notice',
    readAction: 'Read',
    readSuccess: 'Read',
    settlementNo: 'Settlement No.',
    pleaseEnterSettlementNo: 'Enter settlement no.',
    settlementType: 'Settlement Type',
    settlementStatus: 'Settlement Status',
    pleaseSelectSettlementType: 'Select settlement type',
    pleaseSelectSettlementStatus: 'Select settlement status',
    expenditureTransferMethod: 'Expenditure/Transfer Method',
    pleaseSelectItem: 'Select item',
    transferInAgent: 'Transfer In Agent',
    pleaseSelectTransferInAgent: 'Select transfer in agent',
    transferInAccountType: 'Transfer In Account Type',
    pleaseSelectTransferInAccountType: 'Select transfer in account type',
    transferInItem: 'Transfer In Item',
    settlementAmount: 'Settlement Amount',
    lastPayTimeLabel: 'Last Pay Time',
    pleaseEnterCreator: 'Enter creator',
    attachment: 'Attachment',
    accountChangeType: 'Account Change Type',
    accountChangeNotification: 'Account Change Notification',
    pleaseSelectChangeType: 'Select type',
    accountRecharge: 'Account Recharge',
    accountExpense: 'Account Expense',
    accountTransfer: 'Account Transfer',
    unread: 'Unread',
    read: 'Read',
    sendTime: 'Send Time',
    noticeContent: 'Notice Content',
    readLabel: 'Read',
    readSuccess: 'Read',
    pleaseSelectRefundType: 'Select refund type',
    pleaseSelectRefundAccount: 'Select refund account',
    pleaseEnterOrderNoShort: 'Enter order no',
    batchConfirm: 'Batch Confirm',
    batchBindOrder: 'Batch Bind Order',
    confirmRechargeToWithdraw: 'Commission will be recharged to agent withdraw account. Confirm?',
    serviceProviderStatus: 'Service Provider Status',
    rechargeStatus: 'Recharge Status',
    unconfirmed: 'Unconfirmed',
    confirmed: 'Confirmed',
    commissionMonth: 'Commission Month',
    commissionRechargeType: 'Commission Recharge Type',
    returnFirstOrderRebate: 'Return_first_order',
    subscriptionFeeRebate: 'Subscription_fee_rebate',
    commodityAddedServiceFee: 'Commodity_added_service_fee',
    amount: 'Amount',
    generateTime: 'Generate Time',
    confirmBy: 'Confirm By',
    pleaseSelectMonth: 'Select month',
    totalFlowRechargeAmount: '{n} flows, total recharge amount {m} yuan',
    flowStatus: 'Flow Status',
    confirmRemark: 'Confirm Remark',
    financeConfirm: 'Finance Confirm',
    bindOrder: 'Bind Order',
    paymentConfirm: 'Payment Confirm',
    rechargeAmountColon: 'Recharge Amount:',
    rechargeTimeColon: 'Recharge Time:',
    rechargeSerialColon: 'Recharge Serial:',
    flowStatusColon: 'Flow Status:',
    rechargeVoucher: 'Recharge Voucher',
    rechargeVoucherColon: 'Recharge Voucher:',
    returnBack: 'Return Back',
    invalid: 'Invalid',
    reissue: 'Reissue',
    confirmInvalidInvoice: 'Confirm to invalidate this invoice? Cannot be recovered!',
    drawInvoice: 'Draw Invoice',
    isInvalid: 'Is Invalid',
    yes: 'Yes',
    no: 'No',
    pleaseSelectInvalid: 'Select invalid status',
    invoiceNo: 'Invoice No',
    controlInvoicesOrderNo: 'Order No.',
    pleaseEnterInvoiceNo: 'Enter invoice no',
    imageLoadFail: 'Image load failed',
    invalidSuccess: 'Invalidated successfully',
    invalidFail: 'Invalid failed',
    annexPreview: 'Attachment Preview',
    batchBindSuccess: 'Batch bind success',
    batchBindFail: 'Batch bind failed',
    remarkColon: 'Remark:',
    confirmRemarkColon: 'Confirm Remark:',
    indexNo: 'No.',
    projectName: 'Project Name',
    specModel: 'Specification Model',
    itemCount: 'Quantity',
    taxAmount: 'Tax Amount',
    invoiceDate: 'Invoice Date',
    rechargeIdLabel: 'Recharge ID',
    pleaseEnterRechargeId: 'Enter recharge ID',
    payMethodLabel: 'Recharge Method',
    itemType: 'Item',
    payTimeLabel: 'Recharge Time',
    transferAmountLabel: 'Transfer Amount',
    pendingConfirm: 'Pending Confirm',
    pleaseSelectConfirmBy: 'Select confirmer',
    phoneLabel: 'Phone',
    pleaseEnterPhoneShort: 'Enter phone',
    nameLabel: 'Name',
    searchByNamePlaceholder: 'Search by personal name or company head',
    headType: 'Head Type',
    pleaseSelectHeadType: 'Select head type',
    companyHeadOrName: 'Company Head/Personal Name',
    dutyParagraphShort: 'Tax No',
    idCardShort: 'ID Card No',
    invoiceAssortName: 'Invoice Type',
    addressShort: 'Address',
    bankShort: 'Bank',
    bankAccountShort: 'Bank Account',
    cycleExpiryTime: 'Cycle Expiry Time',
    exemptionExpiryNo: 'Exemption Expiry No',
    pleaseEnterNoShort: 'Enter no.',
    agentTypeShort: 'Agent Type',
    pleaseSelectType: 'Select type',
    currentCycle: 'Current Cycle',
    initialBalance: 'Initial Balance',
    currentPeriodReceiveAmount: 'Current Period Receive Amount',
    currentPeriodConsumeAmount: 'Current Period Consume Amount',
    exemptionNonOrderAmount: 'Exemption Non-Order Amount',
    exemptionNonOrderNum: 'Exemption Non-Order Qty',
    estimatedCost: 'Estimated Cost',
    actualCost: 'Actual Cost',
    deductTime: 'Deduct Time',
    deductBy: 'Deduct By',
    obtainRecord: 'Obtain Record',
    transferRecord: 'Transfer Record',
    myIssuedVoucher: 'My Issued Vouchers',
    myVerifiedVoucher: 'My Verified Vouchers',
    myReceivedVoucher: 'My Received Vouchers',
    myConsumedVoucher: 'My Consumed Vouchers',
    equityDesc: 'Equity Description',
    equityDescTitle: 'Equity Description - {name}',
    rightType: 'Right Type',
    pleaseSelectRightType: 'Select right type',
    rightName: 'Right Name',
    pleaseEnterRightName: 'Enter right name',
    rightCode: 'Right Code',
    pleaseEnterRightCode: 'Enter right code',
    grantTime: 'Grant Time',
    obtainTime: 'Obtain Time',
    verifyTime: 'Verify Time',
    recordNo: 'Record No.',
    pleaseEnterRecordNo: 'Enter record no.',
    purchaseOrderNo: 'Purchase Order',
    purchaseNoCol: 'Purchase No.',
    pleaseEnterPurchaseOrder: 'Enter purchase order',
    consumeCampusId: 'Consume Agent ID',
    consumeCampusName: 'Consume Agent Name',
    consumeVoucherAmount: 'Consume Voucher Amount',
    grantCampusId: 'Grant Agent ID',
    grantCampusName: 'Grant Agent Name',
    relatedCampusId: 'Related Agent ID',
    relatedCampusName: 'Related Agent Name',
    consumeBy: 'Consume By',
    grantRemark: 'Grant Remark',
    consumeRemark: 'Consume Remark',
    amount: 'Amount',
    voucherAmount: 'Voucher Amount',
    grantBy: 'Grant By',
    receiveCampusId: 'Receive Agent ID',
    receiveCampusName: 'Receive Agent Name',
    expirationTime: 'Expiration Time',
    verifyCampusId: 'Verify Agent ID',
    verifyCampusName: 'Verify Agent Name',
    verifyAmount: 'Verify Amount',
    verifyOrder: 'Verify Order',
    verifyBy: 'Verify By',
    rightForm: 'Right Form',
    pleaseSelectRightForm: 'Select right form',
    validDeadline: 'Valid Deadline',
    distributeBy: 'Distribute By',
    validityPeriod: 'Validity Period',
    belongDealer: 'Belong Dealer',
    consNo: 'Verify No.',
    consTime: 'Verify Time',
    consType: 'Verify Type',
    consRemark: 'Remark',
    rightLevel: 'Right Level',
    rightAmount: 'Right Amount',
    applicableModel: 'Applicable Model',
    rightDiscount: 'Right Discount',
    marketingActivity: 'Marketing Activity',
    activityPrice: 'Activity Price',
    rightQuantity: 'Right Quantity',
    exclusiveAttr: 'Exclusive Attr',
    withdrawRecord: 'Withdraw Record',
    cashTransferRecord: 'Cash Transfer Record',
    newDoubleOrder: 'New Double Order',
    agentNotActivatedTip: 'This agent account is not activated yet. Continue to create double order?',
    withdrawableAmountColon: 'Withdrawable Amount:',
    withdrawalAccountLabel: 'Withdrawal Account',
    goldAccountBalance: 'Gold Account Balance',
    transferNo: 'Transfer No.',
    transferNum: 'Transfer Qty',
    goldCoinTransferTime: 'Transfer Time',
    transferTime: 'Transfer Time',
    transferOutAccount: 'Transfer Out Account',
    transferInAccount: 'Transfer In Account',
    pleaseSelectAccount: 'Select account',
    pleaseSelectReceiveAccount: 'Select receive account',
    consumeNo: 'Consume No.',
    consumeNum: 'Consume Qty',
    consumeTime: 'Consume Time',
    consumeAccount: 'Consume Account',
    studentName: 'Student Name',
    studentAccount: 'Student Account',
    pleaseEnterStudentName: 'Enter student name',
    obtainNo: 'Obtain No.',
    obtainNum: 'Obtain Qty',
    obtainMethod: 'Obtain Method',
    pleaseSelectObtainMethod: 'Select obtain method',
    obtainTimeLabel: 'Obtain Time',
    obtainUser: 'Obtain User',
    cashAccountBalance: 'Cash Account Balance',
    deliveryVoucherBalance: 'Delivery Voucher Balance',
    subAgentLabel: 'Sub Agent',
    createFail: 'Create failed!',
    nonCompanyWithdrawTip: 'Your agent entity is not a company. Please go to Finance Center -> Invoice -> Invoice Header to apply as company type. After approval, you can apply for withdrawal.',
    applySuccess: 'Application submitted successfully!',
    applyFail: 'Application failed!',
    loanTransferAutoConfirmTip: 'Loan transfer to cash account requires no invoice. Auto-confirmed and amount transferred.',
    transferSuccessTip: 'Submitted successfully. Amount transferred to cash account.',
    exemptionExpiringAmount: 'Exemption Expiring Voucher Amount',
    estimatedStorageFee: 'Estimated Storage Fee',
    agentGoldAccount: 'Agent Gold Account',
    staffGoldAccount: 'Staff Gold Account',
    goToPurchase: 'Go to Purchase',
    jumpToMiniProgram: 'Jump to Mini Program',

    // headTools - Toolset
    snCodeUpdate: 'SN Code Update',
    oldSNCode: 'Old SN Code:',
    newSNCode: 'New SN Code:',
    pleaseEnterOldSNCode: 'Enter old SN code',
    pleaseEnterNewSNCode: 'Enter new SN code',
    addServiceCenter: 'Add Service Center',
    agentId: 'Agent ID',
    serviceAddress: 'Service Address:',
    pleaseEnterAgentId: 'Enter agent ID',
    pleaseEnterServiceAddress: 'Enter service address',
    agentOrderStatusUpdate: 'Agent Order Status Update',
    purchaseNo: 'Purchase No.:',
    purchaseType: 'Purchase Type:',
    orderStatus: 'Order Status:',
    dispatchType: 'Dispatch Type:',
    regionAgentId: 'Region Agent ID',
    pleaseEnterPurchaseNoShort: 'Enter purchase no.',
    pleaseSelectPurchaseType: 'Select purchase type',
    pleaseSelectOrderStatus: 'Select order status',
    pleaseSelectDispatchType: 'Select dispatch type',
    pleaseEnterRegionAgentId: 'Enter region agent ID',
    pleaseEnterRemark: 'Enter remark',
    agentWarehouse: 'Agent Warehouse:',
    pleaseSelectAgentWarehouse: 'Select agent warehouse',

    // headTools - AccountOperation
    applicationType: 'Application Type',
    transferIn: 'Transfer In',
    transferOut: 'Transfer Out',
    transferType: 'Transfer',
    batchTransferIn: 'Batch Transfer In',
    transferOutAgentLabel: 'Transfer Out Agent',
    agentLabel: 'Agent',
    transferInAgent: 'Transfer In Agent',
    payAmountLabel: 'Payment Amount',
    transferOutAmount: 'Transfer Out Amount',
    selectFileAndImport: 'Select file and start import',
    dragOrClick: 'Drag file here or',
    clickUpload: 'click to upload',
    attachments: 'Attachments',
    pleaseEnterRemark200: 'Enter remark, max 200 characters',

    // Common
    balance: 'Balance',
    accountNo: 'Account No.',
    amount: 'Amount',
    time: 'Time',
    status: 'Status',
    yuan: 'CNY',
    errorOccurred: 'An error occurred',
    // Apply status options
    statusPendingSubmit: 'Pending Submit',
    statusPendingAudit: 'Pending Audit',
    statusReturned: 'Returned',
    statusCancelled: 'Cancelled',
    statusPendingPayment: 'Pending Payment',
    statusCompleted: 'Completed',
    pleaseSelectInitialAccount: 'Select initial account',
    pleaseEnterInitialAmount: 'Enter initial amount',
    pleaseSelectPayMethod: 'Select payment method',
    pleaseSelectPayTime: 'Select payment time',
    pleaseEnterPaySerialNo: 'Enter payment serial no.',
    type: 'Commission Recharge Type',
    pleaseSelect: 'Select status',
    jiedanhao: 'Settlement No.',
    mu: 'Project',
    chu: 'Expenditure Method',
    caozuo: 'Operator',
    pleaseEnter: 'Enter return order no.',
    hao: 'ID Card No.',
    estimatedCost: 'Estimated Cost',
    purchaseOrder: 'Purchase Order',
    xiaozhanghu: 'Consume Account',
    student: 'Student',
    name: 'Agent Name',
    zhanghu: 'Bank Account',
    qu: 'Obtain Method',
    chuzhanghu: 'Transfer Out Account',
    ruzhanghu: 'Transfer In Account',
    dianhua: 'Phone',
    dian: 'Email',
    kaihu: 'Bank',
    individual: 'Individual',
    company: 'Company',
    pending: 'Pending',
    already: 'Confirmed',
    month: 'Commission Month',
    queren: 'Confirm By',
    not: 'Unconfirmed',
    danhao: 'Return No.',
    qing: 'Applicant',
    xinli: 'Latest Processor',
    textfhuc: 'Name',
    textxvbf: 'Province',
    text1k65: 'District',
    textpf6n: 'Postcode',
    text6n7l: 'Wang Xiaohu',
    textqeco: 'Shanghai',
    textzd6p: 'Putuo District',
    textiq60: 'Shanghai Putuo District Jinsha River Road',
    textzuxc: 'Name',
    textt7uv: 'Province',
    textkxzs: 'District',
    text7633: 'Postcode',
    textvs5z: 'Wang Xiaohu',
    textyspe: 'Shanghai',
    texteb5j: 'Putuo District',
    textukx3: 'Shanghai Putuo District Jinsha River Road',
    agent2: 'Agent',
    text2gks: 'Product Name',
    text5owf: 'Available Sample Index',
    textmv1l: 'Purchase Device Sample Index',
    textv66y: 'Activity Sample Index',
    textg5ii: 'Used Sample Index',
    equityDescLabel: 'Equity Description:',
    equityUsageLabel: 'Equity Usage Method:',
  financeCenter: {
    valuation: "Valuation",
    auto_1_6b6ece34: "Pay1",
    auto_1_ebc377a4: "Submit failed1",
    auto_2_745edc9e: "Edit2",
    auto_2_d4954d6e: "he xiaoAgent2",
    auto_3_9187db9b: "Verify Agent Name3",
    auto_3_ea766e30: "Invoice Confirmation3",
    auto_4_7027499f: "Serial No.4",
    auto_4_e82041b8: "More4",
    auto_5_6f265697: "Cancel5",
    auto_5_cf628124: "Verify Amount5",
    auto_6_3682d1dc: "Submit6",
    auto_6_dca8bab5: "GrantAgent6",
    auto_7_6f63d67e: "Grant Agent Name7",
    auto_7_c4ce0715: "Change Address7",
    auto_8_92d398e1: "Receipt Confirmation8",
    auto_8_fb1e1ec8: "Verify Order8",
    auto_9_4334790a: "Related Agent9",
    auto_9_729212dd: "Operation9",
    auto_10_0d0eb47b: "Related Agent Name10",
    auto_10_a9f42805: "Pay10",
    auto_11_19f35b07: "Edit11",
    auto_11_5d8b94fd: "Verify Time11",
    auto_12_7a1e0aea: "Verify By12",
    auto_12_9a934775: "Invoice Confirmation12",
    auto_13_797c0418: "Remark13",
    auto_13_df7b22b8: "More13",
    auto_14_1162996f: "Operation14",
    auto_14_88429bf5: "gui shuAgent14",
    auto_15_884eec7f: "Consume Agent Name15",
    auto_15_d6f54305: "Pay15",
    auto_16_28b64976: "Serial No.16",
    auto_16_fb8dd9be: "Edit16",
    auto_17_aad90013: "Voucher Amount17",
    auto_17_c660f5e5: "Invoice Confirmation17",
    auto_18_469e30df: "GrantAgent18",
    auto_18_67962858: "More18",
    auto_19_1a2b2e88: "Operation19",
    auto_19_3b689608: "Grant Agent Name19",
    auto_20_16677134: "Pay20",
    auto_20_c8ded2b2: "Purchase Order20",
    auto_21_68c0645e: "Obtain Time21",
    auto_21_c37f7ef2: "Edit21",
    auto_22_78fb43d0: "Expiration Time22",
    auto_22_b82fc983: "Invoice Confirmation22",
    auto_23_4434e40c: "More23",
    auto_23_4cc548ab: "Remark23",
    auto_24_1f4283f9: "gui shuAgent24",
    auto_24_f4c2d691: "Operation24",
    auto_25_0e997a9f: "Cancel25",
    auto_25_5194ce27: "Consume Agent Name25",
    auto_26_c44a0dff: "thisonSureOrderrecordFinance Confirm26",
    auto_26_f87a9ffd: "Serial No.26",
    auto_27_b1784121: "thisBindOrderrecordrechargeIdt27",
    auto_27_b3b45e9e: "Consume Voucher Amount27",
    auto_28_41f30956: "GrantAgent28",
    auto_29_8255c8cb: "Grant Agent Name29",
    auto_30_8cbda33e: "Purchase Order30",
    auto_31_4c4fdf72: "Related Agent31",
    auto_32_d8363811: "Related Agent Name32",
    auto_33_8c1fbd78: "Distribution Time33",
    auto_34_37f1b74c: "Consume By34",
    auto_34_d0862854: "Payment34",
    auto_35_155cd631: "Grant Remark35",
    auto_35_ce7a09eb: "Detail35",
    auto_36_a15a703b: "Consume Remark36",
    auto_36_e8c4a85c: "text36",
    auto_37_2057c69a: "Serial No.37",
    auto_37_55a03750: "Label37",
    auto_38_bb8b4786: "Consume Qty38",
    auto_39_9e95e46b: "Consume Time39",
    auto_39_e3ee3b18: "guan yu yang jiIndicatorde gui ze ji jie du39",
    auto_40_a8a43348: "Testwu liu40",
    auto_40_bafe5d5f: "Consume Account40",
    auto_41_65ec2f30: "Student Name41",
    auto_42_4711b9cd: "Student Account42",
    auto_43_fd6f12d4: "Operator43",
    auto_44_39032079: "Remark44",
    auto_45_1f40693b: "Serial No.45",
    auto_46_73372523: "Obtain Qty46",
    auto_47_2c39e54a: "Obtain Method47",
    auto_48_53c95de1: "Obtain Time48",
    auto_49_3ebd895a: "Obtain User49",
    auto_50_689c2aaf: "Operator50",
    auto_51_1a4fb740: "Remark51",
    auto_52_d17a4725: "Wang Xiaohu52",
    auto_53_28a9915d: "Shanghai53",
    auto_54_d648a147: "Putuo District54",
    auto_55_5f6611f6: "Shanghai Putuo District Jinsha River Road55",
    auto_56_3ee2dbc5: "Wang Xiaohu56",
    auto_57_2451d523: "Shanghai57",
    auto_58_ca225558: "Putuo District58",
    auto_59_2d6a5ca7: "Shanghai Putuo District Jinsha River Road59",
    auto_60_898bbf9d: "Wang Xiaohu60",
    auto_61_97f5b154: "Shanghai61",
    auto_62_56cec1b0: "Putuo District62",
    auto_63_f7968f67: "Shanghai Putuo District Jinsha River Road63",
    auto_64_f6b2ed60: "Wang Xiaohu64",
    auto_65_3de41d78: "Shanghai65",
    auto_66_7c5347c4: "Putuo District66",
    auto_67_6b0e8395: "Shanghai Putuo District Jinsha River Road67",
    auto_68_5d335e58: "Wang Xiaohu68",
    auto_69_f87aa3f3: "Shanghai69",
    auto_70_b2bc7a8e: "Putuo District70",
    auto_71_49370797: "Shanghai Putuo District Jinsha River Road71",
    auto_72_ee82bb93: "Wang Xiaohu72",
    auto_73_957bbacc: "Shanghai73",
    auto_74_8d817d9c: "Putuo District74",
    auto_75_a57308c1: "Shanghai Putuo District Jinsha River Road75",
    auto_76_0ef701f3: "Wang Xiaohu76",
    auto_77_596b3f41: "Shanghai77",
    auto_78_26a95388: "Putuo District78",
    auto_79_66e61787: "Shanghai Putuo District Jinsha River Road79",
    auto_80_ef2308ce: "Wang Xiaohu80",
    auto_81_816335b0: "Shanghai81",
    auto_82_5093ffa7: "Putuo District82",
    auto_83_cec78619: "Shanghai Putuo District Jinsha River Road83",
    auto_84_06813cd6: "Serial No.84",
    auto_85_6d496bf0: "Transfer Qty85",
    auto_86_a845dd6a: "Transfer Time86",
    auto_87_3cfcfaf4: "Transfer Out Account87",
    auto_88_7c8ab76b: "Transfer In Account88",
    auto_89_c114f60c: "Operator89",
    auto_90_18862e79: "Remark90",
    auto_91_05b422f9: "Agent91",
    auto_92_28409628: "Agent Name92",
    auto_93_56609012: "Gold Account Balance93",
    auto_94_e17c9a8e: "Cash Account Balance94",
    auto_95_82ecdc81: "Delivery Voucher Balance95",
    auto_97_7a3becf5: "Visit Store Address97",
    auto_98_38685431: "Sign Time98",
    auto_99_73621379: "text99",
    auto_100_cb775405: "Visit Campus Name100",
    auto_101_1fd8d725: "text101",
    auto_102_f3526d82: "Sign Time102",
    auto_103_0dd369f2: "Visit Store Address103",
    auto_104_3f064d4d: "Related Agent104",
    auto_105_73f5d318: "Related Agent Name105",
    auto_106_72c70ecf: "Serial No.106",
    auto_107_ea502f26: "Voucher Amount107",
    auto_108_65a5c8a5: "GrantAgent108",
    auto_109_12710029: "Grant Agent Name109",
    auto_110_67642bea: "Purchase Order110",
    auto_111_a2375f4e: "Distribution Time111",
    auto_112_e9efec21: "Grant By112",
    auto_113_a2269a72: "Remark113",
    auto_114_eb8a1b4d: "(advance)",
    auto_116_18891eb0: "Agent116",
    auto_117_e20fb753: "Confirmed117",
    auto_118_5a6ea357: "Remaining Unordered Amount118",
    auto_119_10de635d: "Individual119",
    auto_120_7f351f27: "Company120",
    auto_121_dae829e2: "Unread121",
    auto_122_f2d5d8b1: "Recharge122",
    auto_123_72c869d7: "Recharge123"
  }
  }
}
